import { FilterMatchMode } from 'primereact/api';

export const initialFormData = {
    serviceDeliveryDate: '',
    chassisNumber: '',
    customer: '',
    customerName: '',
    customerPhone: '',
    declaration: '',
    kilometer: 0,
    plateNumber: '',
    brand: 0,
    model: 0,
    registrationDate: '',
    receivedBy: '',
    deliveredBy: '',
    bosBranchCode: '',
    bosBranchSiteCode: '',
    chassisDescription: '',
    lastKmInfo: 0,
    warrantyBeginDate: null,
    warrantyEndDate: null,
    customerNameSurname: '',
    isDomestic: false,
    hasWarrantyClaim: false,
    status: 0,
    balanceInfo: '',
    serviceNote: ''
};

export const initialFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    plateNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    chassisNumber: { value: null, matchMode: FilterMatchMode.CONTAINS }
};